import React, { useEffect, useState } from 'react';
import useBrandContext from 'contexts/brand.context';
import { apiService } from 'services/base.service';
import { Switch, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as HexagonIcon } from 'assets/icons/hexagon.svg';
import { POLYGON_COLORS } from 'utils/constants';
import { toast } from 'react-toastify';
import { PolygonType } from 'utils/types';
import { SuccessModal } from 'components/base/success-modal';
import SingleBottomNav from 'components/base/single-bottom-nav';

const EditBrandPolygon = () => {
  const { activeBrand, setActiveBrand, availablePolygons } = useBrandContext();
  const [polygons, setPolygons] = useState<PolygonType[]>([]);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const excludedPolygonId = activeBrand.excluded_polygon_ids ?? [];
  const handleToggle = (polygonId: string) => {
    setPolygons((prev) =>
      prev.map((p) => (p.id === polygonId ? { ...p, available: !p.available } : p))
    );
  };

  const updateBrandDetails = async () => {
    if (!activeBrand?.cokitchen_id) {
      return;
    }
    setLoading(true);
    try {
      const updatedPolygonIds = polygons.filter((p) => !p.available).map((p) => p.id);

      await apiService.put(`marketing/brand`, {
        data: {
          cokitchen_id: activeBrand.cokitchen_id,
          excluded_polygon_ids: updatedPolygonIds,
          brand_id: activeBrand.id
        },
        isInternal: true
      });
      if (setActiveBrand) {
        setActiveBrand({
          ...activeBrand,
          polygon_ids: updatedPolygonIds
        });
      }

      toast(<ToastMessage type='success' message='Polygons updated successfully' />);
      setShowSuccess(true);
    } catch (error) {
      toast(
        <ToastMessage type='error' message={`Error updating polygons for ${activeBrand?.name}`} />
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPolygons(
      availablePolygons.map((p) => {
        if (excludedPolygonId.includes(p.id)) {
          return { ...p, available: false };
        } else {
          return { ...p, available: true };
        }
      })
    );
  }, [availablePolygons]);
  return (
    <div className='max-w-full '>
      <div className='bg-gray-100 px-4 py-2 font-semibold text-sm text-gray-5'>
        Edit Brand Polygons
      </div>

      {polygons.map((polygon, index) => (
        <div
          key={polygon.id}
          className={`flex items-center justify-between px-4 py-3  ${
            index === polygons.length - 1 ? 'border-b-0' : ''
          }`}>
          <div className='flex items-center gap-3'>
            <HexagonIcon style={{ color: POLYGON_COLORS[index]?.color_code }} />
            <span className='text-gray-800'>{polygon.name}</span>
          </div>
          <Switch
            active={polygon.available}
            disabled={loading}
            onChange={() => handleToggle(polygon.id)}
          />
        </div>
      ))}

      <SingleBottomNav
        loading={loading}
        onConfirm={updateBrandDetails}
        backBtndisabled
        btnDisabled={loading}
      />

      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Brand updated successfully
      </SuccessModal>
    </div>
  );
};

export default EditBrandPolygon;
